import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import posSessionApi from "../../api/posSessionApi";
import { useTranslation } from "react-i18next";
import axios from "../../axios";

export default function PosSessionReport() {
  const { sessionId } = useParams();
  const { t } = useTranslation();
  const [session, setSession] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const sessionRes = await posSessionApi.getSessionHistory({ from: null, to: null }); 
        // Note: Ideally getById, but currently using history or I should implement getById in backend or filter from history
        // Let's assume we can fetch by ID or just use what we have. 
        // For now, I will add a getById endpoint in backend or just rely on the passed object if possible?
        // No, print page is separate.
        // Let's implement getById in backend quickly or just filter from history if small.
        // Actually, let's just fetch the session summary if it's the current one, or from history.
        // Wait, I need a getById endpoint for session to be clean.
        // But for now, let's try to get it from the history list since we don't have getById yet.
        
        // BETTER: I will quickly add GetById to the backend controller in the next step to be correct.
        // For now, let's scaffold the UI.
        
        // Mocking for now until I add the endpoint
        const sessionList = await posSessionApi.getSessionHistory({});
        const found = sessionList.data.find(s => s.id === parseInt(sessionId));
        setSession(found);

        const compRes = await axios.get('/CompanyProfile');
        setCompany(compRes.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [sessionId]);

  useEffect(() => {
    if (session && company) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [session, company]);

  if (loading) return <div>Loading...</div>;
  if (!session) return <div>Session not found</div>;

  return (
    <div className="p-2 max-w-[80mm] mx-auto bg-white text-black text-xs" dir="rtl" style={{ fontFamily: 'Cairo, sans-serif' }}>
      <style>{`
        @media print {
          @page { size: 80mm auto; margin: 0; }
          body { background: white; margin: 0; padding: 0; }
          .no-print { display: none !important; }
        }
      `}</style>

      {/* Header */}
      <div className="text-center mb-4 border-b border-gray-800 pb-2">
        <h1 className="text-xl font-bold mb-1">{company?.companyNameAr || "اسم الشركة"}</h1>
        <p className="text-[10px] text-gray-600">{company?.address || ""}</p>
        <p className="text-[10px] text-gray-600">هاتف: {company?.phone || ""}</p>
        <h2 className="text-lg font-bold mt-2 border border-black inline-block px-2 py-0.5 rounded">إغلاق وردية</h2>
      </div>

      {/* Session Info */}
      <div className="mb-4 text-[11px] space-y-1">
        <div className="flex justify-between">
          <span className="font-bold">رقم الجلسة:</span> <span>{session.id}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-bold">المستخدم:</span> <span>{session.user?.username || session.userId}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-bold">الفرع:</span> <span>{session.branchId}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-bold">الفتح:</span> <span>{new Date(session.openedAt).toLocaleString('en-GB', { hour12: true, fontSize: '10px' })}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-bold">الإغلاق:</span> <span>{session.closedAt ? new Date(session.closedAt).toLocaleString('en-GB', { hour12: true }) : "-"}</span>
        </div>
      </div>

      {/* Financials Table */}
      <table className="w-full mb-4 border-collapse border border-gray-800 text-[11px]">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-800 p-1 text-right">البيان</th>
            <th className="border border-gray-800 p-1 text-center">القيمة</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-gray-800 p-1 font-bold">رصيد الافتتاح</td>
            <td className="border border-gray-800 p-1 text-center font-bold">{session.openingBalance.toFixed(2)}</td>
          </tr>
          <tr>
            <td className="border border-gray-800 p-1">مبيعات نقدية</td>
            <td className="border border-gray-800 p-1 text-center">{session.totalCashSales.toFixed(2)}</td>
          </tr>
          <tr>
            <td className="border border-gray-800 p-1">مبيعات شبكة</td>
            <td className="border border-gray-800 p-1 text-center">{session.totalCardSales.toFixed(2)}</td>
          </tr>
          <tr>
            <td className="border border-gray-800 p-1">تحويل بنكي</td>
            <td className="border border-gray-800 p-1 text-center">{session.totalBankTransferSales?.toFixed(2) || "0.00"}</td>
          </tr>
          <tr>
            <td className="border border-gray-800 p-1">مبيعات آجل</td>
            <td className="border border-gray-800 p-1 text-center">{session.totalCreditSales.toFixed(2)}</td>
          </tr>
          <tr>
            <td className="border border-gray-800 p-1 text-red-600">مرتجعات</td>
            <td className="border border-gray-800 p-1 text-center text-red-600">({session.totalReturns.toFixed(2)})</td>
          </tr>
          <tr className="bg-gray-200">
            <td className="border border-gray-800 p-1 font-bold">صافي المبيعات</td>
            <td className="border border-gray-800 p-1 text-center font-bold">
              {((session.totalCashSales + session.totalCardSales + (session.totalBankTransferSales||0) + session.totalCreditSales) - session.totalReturns).toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Cash Reconciliation */}
      <div className="border border-gray-800 p-2 rounded mb-4 text-[11px]">
        <h3 className="font-bold mb-2 underline text-center">مطابقة النقدية</h3>
        <div className="space-y-1">
          <div className="flex justify-between">
             <span>المتوقع بالدرج:</span>
             <span className="font-bold">{(session.openingBalance + session.totalCashSales - session.totalReturns).toFixed(2)}</span>
          </div>
          
          <div className="flex justify-between">
             <span>الفعلي (العد):</span>
             <span className="font-bold">{session.closingBalance.toFixed(2)}</span>
          </div>
          
          <div className="flex justify-between border-t border-gray-400 pt-1 mt-1">
             <span className="font-bold">الفارق:</span>
             <span className={`font-bold ${session.variance < 0 ? 'text-red-600' : 'text-green-600'}`}>
               {session.variance.toFixed(2)}
             </span>
          </div>
        </div>
      </div>

      {/* Notes */}
      {session.notes && (
        <div className="mb-4 text-[10px]">
          <h3 className="font-bold mb-1">ملاحظات:</h3>
          <p className="border border-gray-300 p-1 rounded">{session.notes}</p>
        </div>
      )}

      {/* Signatures */}
      <div className="flex justify-between mt-8 text-[10px]">
        <div className="text-center w-1/2">
          <p className="font-bold mb-6">الكاشير</p>
          <p>................</p>
        </div>
        <div className="text-center w-1/2">
          <p className="font-bold mb-6">المشرف</p>
          <p>................</p>
        </div>
      </div>
      
      <div className="text-center text-[9px] text-gray-500 mt-4">
        {new Date().toLocaleString()}
      </div>
    </div>
  );
}
